import React from "react";
import css from "./StartYourFreeTrial.module.css";
import IconCard from "../../../../../components/SavedCardDetails/IconCard/IconCard";
import { FormattedMessage } from "react-intl";
import { NamedLink } from "../../../../../components";

function StartYourFreeTrial() {
    return (
        <div className={css.container}>
            <div className={css.middleSection}>
                <div className={css.leftIconWrapper}>
                    <IconCard type="laughicon" />
                </div>
                <div>
                    <h2 className={css.title}>
                        <FormattedMessage id="StartYourFreeTrial.liveWithExpertTutors" />
                    </h2>
                    <button className={css.orangeButton}>
                        <IconCard type="lightningicon" />
                        <span><FormattedMessage id="StartYourFreeTrial.tryTwoFree" /></span>
                        <IconCard type="lightningicon" />
                    </button>
                </div>
            </div>

            <div className={css.rightSection}>
                <div>
                    <p className={css.description}>
                        <FormattedMessage id="StartYourFreeTrial.takeTrialLessons" />
                    </p>
                    <div className={css.buttonRow}>
                        <NamedLink name='SearchPage' className={css.greenButton}>
                            <FormattedMessage id="StartYourFreeTrial.startYourFreeTrial" />
                            <IconCard type="doublearrow" />
                        </NamedLink>
                        <div className={css.noPayment}><FormattedMessage id="StartYourFreeTrial.noPaymentRequired" /></div>
                    </div>
                </div>
                <div className={css.rightIconWrapper}>
                    <IconCard type="ledbulb" />
                </div>
            </div>

        </div>
    );
}

export default StartYourFreeTrial;